import { render, staticRenderFns } from "./LayoutContentWithSidebar.vue?vue&type=template&id=3acfef11&scoped=true"
import script from "./LayoutContentWithSidebar.vue?vue&type=script&lang=js"
export * from "./LayoutContentWithSidebar.vue?vue&type=script&lang=js"
import style0 from "./LayoutContentWithSidebar.vue?vue&type=style&index=0&id=3acfef11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acfef11",
  null
  
)

export default component.exports